import {AbstractService} from 'services/AbstractService';


const AD_FORMATS_LIST = '/api/channels/ad/formats';


export class AdFormatsService extends AbstractService {
  async getAdFormats () {
    const data = await this.client.get(AD_FORMATS_LIST);
    return data.items;
  }
}
